import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Copy_clipboard, Popup, Text, Select, MultipleSelect} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function Webhook_setup_popup(props){

  function onSubmit(params){
    if(params.companies==undefined){params.companies=false;}
    if(params.contacts==undefined){params.contacts=false;}
    if(params.timeline_items==undefined){params.timeline_items=false;}
    if(props.webhook_setup=='NEW'){props.createWebhook(params);}
    else{props.updateWebhook(params);}
  }
  const delete_policy_options=[{id:0, name:'Isolate deletes'}, {id:1, name:'Delete only on ProspectSafari'}, {id:2, name:'Delete only on your system'}, {id:3, name:'Delete both ways'}];

  let initial_webhook_setup={};
  if(props.webhook_setup!='NEW'){initial_webhook_setup=JSON.parse(JSON.stringify(props.webhook_setup));}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_webhook_setup}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='Webhook setup' content={
          <div style={{width:'95vw', maxWidth:'600px', marginTop:'20px'}}>
              <Grid container style={{width:'calc(100% - 30px)', marginLeft:'10px'}}>
              {(initial_webhook_setup.signature==undefined)?undefined:<div style={{marginTop:'0px', marginBottom:'40px', width:'calc(100% - 20px)', marginLeft:'10px'}}><Copy_clipboard title='Signature' textToCopy={initial_webhook_setup.signature}/></div>}
              <Grid item xs={6}><Text title='Name' name='name' required/></Grid>
              <Grid item xs={6}><Text title='Url' name='url' required/></Grid>
              <Grid itemx xs={12} style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='companies'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} name="companies" color="primary"/>}label='Companies'/>}</Field></Grid>
              <Grid itemx xs={12} style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='contacts'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} name="contacts" color="primary"/>}label='Contacts'/>}</Field></Grid>
              <Grid itemx xs={12} style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='timeline_items'>{(f)=><FormControlLabel control={<Checkbox disabled checked={f.input.value} onChange={f.input.onChange} name="timeline_items" color="primary"/>}label="Timeline items (coming soon)"/>}</Field></Grid>
            </Grid>
          </div>
        }/>
        </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(Webhook_setup_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createWebhook:(params)=>{dispatch({type:'REQUEST_CREATE_WEBHOOKS', payload:params})},
    updateWebhook:(params)=>{dispatch({type:'REQUEST_UPDATE_WEBHOOKS', payload:params})}
  }
}
